import { useCallback, useEffect, useState } from 'react';
import { getTripEvents, type TripLogEntry } from '../trips.api';

export type TripEventsState = { status: 'loading' } | { status: 'loaded'; events: TripLogEntry[] } | { status: 'error' };

/** Pass null to read nothing (the state stays `loading`). */
export function useTripEvents(tripId: string | null) {
  const [state, setState] = useState<TripEventsState>({ status: 'loading' });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!tripId) return;
    let cancelled = false;
    getTripEvents(tripId)
      .then(({ events }) => {
        if (!cancelled) setState({ status: 'loaded', events });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, [tripId, attempt]);

  const retry = useCallback(() => {
    setState({ status: 'loading' });
    setAttempt((count) => count + 1);
  }, []);

  return { state, retry };
}
